<template>
  <b-modal
    id="interac-instructions-modal"
    :title="trans('interac_e_transfer')"
    hide-footer
    @shown="fetch"
  >
    <interac-instructions
      v-if="!!interac"
      :organization="organization"
      :interac="interac"
    ></interac-instructions>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
    <p v-html="organization.assistance"></p>
  </b-modal>
</template>

<script>
  import InteracInstructions from './InteracInstructions'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      url: String,
    },
    components: {
      InteracInstructions,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        interac: this.invoice ? (this.invoice.interac || null) : null,
      }
    },
    watch: {
      invoice() {
        this.interac = this.invoice.interac
      },
    },
    methods: {
      fetch() {
        if (this.interac) return
        this.busy = true
        this.error = false
        const url = this.url || `/organization/${this.organization.id}/invoice/no/${this.invoice.invoice_no}/interac`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.interac = response.data.interac
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
  }
</script>